// extracted by mini-css-extract-plugin
export default {"key_flex":"key_key_flex__iARNK","country_name":"key_country_name__P9rKS","respondant":"key_respondant__RCDM5"};